
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftRight25 as ObiThreewayAcuatorPistonInleftRight25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-right-25.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftRight25 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-right-25',
   elementClass: ObiThreewayAcuatorPistonInleftRight25Element,
   events: {
     
   }
  });
 
 